import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';
import ScrollableContainer from 'components/shared/scrollable';
import FeatureFlag from 'components/shared/FeatureFlag';
import StickySidebar from 'components/shared/StickySidebar';
import PathAssociatedSkills from 'components/Skills/Path/PathAssociatedSkills';
import { hasGlobalFeature } from 'selectors';
import Badge from './Badge';
import HistoryInfo from './History';
import Description from './Description';
import CompletionOrder from './CompletionOrder';
import ContentType from './ContentType';
import Tagging from './Tagging';
import Owners from './Owners';
import LearningLibrary from './LearningLibrary';
import Sharing from './Sharing';
import Buttons from './Buttons';
import ChromeMappings from './ChromeMappings';
import WebWidgetMappings from './WebWidgetMappings';
import PathImage from './PathImage';
import Workspace from './Workspace';
import CompletionTime from './CompletionTime';
import Distributors from './Distributors';
import ExpirationSettings from './ExpirationSettings';

const PathBuilderSidebar = ({
  hasCreatedPath,
  features,
  isPublished,
  isCertification,
  userCanManageContent,
  userCanDistributeContent,
  hasMultipleWorkspaces,
}) => (
  <StickySidebar className="PathBuilderSidebar">
    <ScrollableContainer maxHeight={null} hidden>
      <Buttons />
      {isCertification && <Badge />}
      <Description />
      <CompletionOrder />
      {isCertification && <ExpirationSettings />}
      {hasCreatedPath && userCanManageContent && <Sharing />}
      {isPublished && userCanDistributeContent && <LearningLibrary />}
      {userCanManageContent && <CompletionTime />}
      <FeatureFlag features={['skills']}>
        <PathAssociatedSkills />
      </FeatureFlag>
      {hasCreatedPath && userCanDistributeContent && <Tagging />}
      {hasCreatedPath && userCanManageContent && <Owners />}
      {hasCreatedPath && userCanDistributeContent && <Distributors />}
      {isPublished && features.relatedUrls && userCanManageContent && (
        <ChromeMappings />
      )}
      {hasCreatedPath && userCanManageContent && <PathImage />}
      <HistoryInfo />
      {!isCertification && userCanManageContent && <ContentType />}
      {features.workspaces && hasMultipleWorkspaces && userCanManageContent && (
        <Workspace />
      )}
      {isPublished && features.webWidget && userCanManageContent && (
        <WebWidgetMappings />
      )}
    </ScrollableContainer>
  </StickySidebar>
);

const mapStateToProps = ({ pathBuilder, ...state }) => {
  const hasFeature = feature => hasGlobalFeature(state, feature);
  return {
    hasCreatedPath: !!pathBuilder.id,
    isCertification: !!get('certification')(pathBuilder),
    isPublished: !!get('publishedAt.date')(pathBuilder),
    hasMultipleWorkspaces: state.meta.workspaces.length > 1,
    features: {
      relatedUrls: hasFeature('related_urls'),
      webWidget: hasFeature('web_widget'),
      workspaces: hasFeature('workspaces'),
    },
    userCanManageContent: pathBuilder.permissions.editPath,
    userCanDistributeContent: pathBuilder.permissions.distributePath,
  };
};

export default connect(mapStateToProps)(PathBuilderSidebar);
